import React, { FunctionComponent, useContext } from 'react';
import BikeRelay40YearsGoogleMap from './bike-relay-40-years-google-map';
import { BikeRelay40YearsContext } from './context/bike-relay-40-years-context';
import BikeRelay40YearsInfo from './bike-relay-40-years-info';

export const BikeRelay40Years: FunctionComponent = () => {
  // use memoization to prevent re-rendering
  const { relayPoints } = useContext(BikeRelay40YearsContext);

  return (
    <div>
      <h1>De Hypotheekadfiets</h1>
      <div className={`mb-4`}>
        <p className={`mb-4`}>
          Jazeker! Dit jaar vieren we onze 40e verjaardag. Een prachtig jubileum dat we natuurlijk
          niet onopgemerkt voorbij laten gaan. Een manier om stil te staan bij onze verjaardag is
          door met z’n allen in beweging te komen. We springen op de pedalen!
        </p>
        <p className={`mb-4`}>
          Vanaf maart t/m november trekt onze speciale De Hypotheker-bakfiets van vestiging naar
          vestiging. Samen met alle collega's van De Hypotheker gaat de elektrische bakfiets in
          estafette door heel het land langs onze vestigingen. De tocht begint 4 maart op de plek
          waar het in 1985 allemaal begon: de mooie Hanzestad Zwolle. In november komt de fiets
          feestelijk aan bij het hoofdkantoor in Capelle aan den IJssel.
        </p>
        <p className={`mb-4`}>
          Met onze fietstocht hopen we niet alleen veel kilometers weg te trappen, maar ook veel
          geld op te halen voor Het Vergeten Kind.
        </p>
        <p className={`mb-4`}>
          Wil je weten waar de fiets nu is en hoe veel kilometer er al gefietst is? Volg het hier!
        </p>
      </div>
      <BikeRelay40YearsInfo></BikeRelay40YearsInfo>
      <BikeRelay40YearsGoogleMap
        apiKey={`AIzaSyDHMbJ5JBYgOnXI8ukdzxK5gIlPKHUK_ds`}
        center={{ lat: 52.5130697, lng: 6.0903152 }}
        zoom={11}
        relayPoints={relayPoints}></BikeRelay40YearsGoogleMap>
    </div>
  );
};

export default BikeRelay40Years;
